// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"7fd5944b","900":"615a0115"}[chunkId] + ".chunk.js";
};